import type { FC } from "react";
import { Alert } from "react-bootstrap";

interface Props {
  mood: { mood: number | null; moodText: string | null; selfReflectionText: string | null };
}

export const SelfReflection: FC<Props> = ({ mood }) => {
  if (!mood.moodText && !mood.selfReflectionText) return null;
  return (
    <>
      <Alert variant={"secondary"} className={"alert--icon-info-vertical"}>
        {mood.moodText ? (
          <>
            <p className="text-center mb-1">
              <strong>Pochvala z minula:</strong>
            </p>
            <p className="text-center">
              <i>{`„${mood.moodText}“`}</i>
            </p>
          </>
        ) : null}

        {mood.moodText && mood.selfReflectionText ? <hr /> : null}

        {mood.selfReflectionText ? (
          <>
            <p className="text-center mb-1">
              <strong>Předsevzetí z minula:</strong>
            </p>
            <p className="text-center">
              <i>{`„${mood.selfReflectionText}“`}</i>
            </p>
          </>
        ) : null}
      </Alert>
    </>
  );
};
